<template>
  <div class="editinfo">
    <el-dialog title="编辑人个信息" :close-on-click-modal="false" :visible.sync="display" top="10vh" @close='closeDialog'>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-row>
          <el-col :span="12" class="text-center">
            <el-form-item label="姓名" prop="name">
              <el-tooltip class="item" effect="dark" :disabled="!fullNameAllowEdit"
                content="购买过会员套餐的人才不支持修改姓名，如需修改请联系职业顾问" placement="top-start">
                <el-input v-model="form.name" :disabled="fullNameAllowEdit">
                </el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="性别" prop="sex_id">
              <el-select class="width_full" v-model="form.sex_id" placeholder="请选择">
                <el-option v-for="item in sexes" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出生日期" prop="birth">
              <el-date-picker v-model="form.birth" type="date" placeholder="选择日期" format="yyyy/MM/dd"
                value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
            </el-form-item>
            <el-form-item label="户籍" prop="native_city_id">
              <el-cascader class="width_full" v-model="form.native_city_id" :options="twoLevelCitys"
                @change="onNativeCityChange"></el-cascader>
            </el-form-item>
            <el-form-item label="居住地区" prop="live_city_id">
              <el-cascader class="width_full" v-model="form.live_city_id" :options="citys" @change="onLiveCityChange">
              </el-cascader>
            </el-form-item>
            <el-form-item label="手机">
              <el-input v-model="form.mobile" size="medium">
                <template slot="append">
                  <el-popover title="验证码" width="200" trigger="manual" v-model="mobileVerifyVisible">
                    <div>
                      <el-input v-model="mobileVerifyCode" placeholder="6 位数字"></el-input>
                      <div style="text-align: right; margin: 8px 0 0 0;">
                        <el-button size="mini" type="text" @click="mobileVerifyVisible = false">取消</el-button>
                        <el-button type="primary" size="mini" @click="onChangeMobile">确定</el-button>
                      </div>
                    </div>
                    <el-button slot="reference" size="small" :disabled="mobileVerifyDisabled"
                      @click="getMobileVerifyCode">{{mobileVerifyText}}</el-button>
                  </el-popover>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="工作年限" prop="work_year">
              <el-input v-model="form.work_year"></el-input>
            </el-form-item>
            <el-form-item label="体重" prop="weight">
              <el-input v-model="form.weight">
                <template slot="append">kg</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="text-center">
            <simple-cropper :initParam="uploadParam" :successCallback="uploadHandle" ref="cropper"
              style="height:186px;">
              <div class="useravatar-shadow-container" @mouseenter="showShadow" @mouseleave="hideShadow">
                <user-avatar :src="form.photo" className="useravatar-big"></user-avatar>
                <img v-show="isShowShadow" src="../assets/images/shadow_tx.png" class="shadow-useravatar-big"
                  @click="upload" />
              </div>
            </simple-cropper>
            <el-form-item label="婚姻状况" prop="married_status_id">
              <el-select class="width_full" v-model="form.married_status_id" placeholder="请选择">
                <el-option v-for="item in marriedstatus" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="详细住址">
              <el-input v-model="form.live_address" size="medium"></el-input>
            </el-form-item>
            <el-form-item label="邮箱">
              <el-input v-model="form.email" size="medium">
                <template slot="append">
                  <el-popover title="验证码" width="200" trigger="manual" v-model="emailVerifyVisible">
                    <div>
                      <el-input v-model="emailVerifyCode" placeholder="6 位数字"></el-input>
                      <div style="text-align: right; margin: 8px 0 0 0;">
                        <el-button size="mini" type="text" @click="emailVerifyVisible = false">取消</el-button>
                        <el-button type="primary" size="mini" @click="onChangeEmail">确定</el-button>
                      </div>
                    </div>
                    <el-button slot="reference" size="small" :disabled="emailVerifyDisabled"
                      @click="getEmailVerifyCode">{{emailVerifyText}}</el-button>
                  </el-popover>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="身高" prop="height">
              <el-input v-model="form.height">
                <template slot="append">cm</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import cityList from '~/static/citys';
  import {
    getMobileVerifyCode,
    changeMobile,
    getEmailVerifyCode,
    changeEmail,
    hasMeRecord
  } from '~/api/user';
  import {
    fullCityName
  } from '~/api/resume';
  import SimpleCropper from '~/components/SimpleCropper';
  import userAvatar from '~/components/UserAvatar';
  import {
    isOneNumberDecimal
  } from '~/utils/validate';

  export default {
    components: {
      SimpleCropper,
      userAvatar
    },
    props: {
      data: {
        type: Object,
        default: {}
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    computed: {},
    data() {
      return {
        form: {},
        sexes: [{
          value: 1,
          label: '男'
        },
        {
          value: 2,
          label: '女'
        }
        ],
        marriedstatus: [{
          value: 87,
          label: '保密'
        }, {
          value: 8,
          label: '未婚'
        }, {
          value: 9,
          label: '已婚'
        }, {
          value: 10,
          label: '离异'
        }],
        twoLevelCitys: [],
        citys: cityList.data,
        display: false,
        rules: {
          name: [{
            required: true,
            message: '请输入会员姓名',
            trigger: 'blur'
          }],
          sex_id: [{
            required: true,
            message: '请选择性别',
            trigger: 'change'
          }, {
            type: 'number',
            min: 1,
            message: '请选择性别',
            trigger: 'blur'
          }],
          native_city_id: [{
            required: true,
            message: '请选择户籍',
            trigger: 'change'
          }],
          live_city_id: [{
            required: true,
            message: '请选择居住地址',
            trigger: 'change'
          }],
          married_status_id: [{
            required: true,
            message: '请选择婚育情况',
            trigger: 'change'
          }, {
            type: 'number',
            min: 1,
            message: '请选择婚育情况',
            trigger: 'blur'
          }],
          birth: [{
            required: true,
            message: '请选择出生日期',
            trigger: 'change'
          }],
          work_year: [{
            required: true,
            message: '请输入工作年限',
            trigger: 'blur'
          }],
          height: [{
            validator: isOneNumberDecimal,
            trigger: 'blur'
          }],
          weight: [{
            validator: isOneNumberDecimal,
            trigger: 'blur'
          }],
        },
        uploadParam: {
          fileType: 'recruit', // 其他上传参数  
          // eslint-disable-next-line no-undef
          uploadURL: process.env.BASE_API + '/Resume/ChangeProfilePhoto', // 上传地址  
          scale: 1 // 相对手机屏幕放大的倍数: 4倍  
        },
        isShowShadow: false,
        mobileTime: 0,
        mobileVerifyCode: '',
        mobileVerifyDisabled: false,
        mobileVerifyText: '验证',
        mobileVerifyVisible: false,

        emailTime: 0,
        emailVerifyCode: '',
        emailVerifyDisabled: false,
        emailVerifyText: '验证',
        emailVerifyVisible: false,

        fullNameAllowEdit: false,
      };
    },
    created() {
      this.hasMeRecord();
    },
    mounted() {
      var allCity = JSON.parse(JSON.stringify(cityList.data));
      allCity.forEach(province => {
        province.children.forEach(city => {
          city.children = null;
        });
      });
      this.twoLevelCitys = allCity;
    },
    watch: {
      data: function (value) {
        this.form = Object.assign({}, value);
        this.form.birth = new Date(this.form.birth);
      },
      visible: function (value) {
        this.display = value;
        if (this.display && this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      },
      mobileTime() {
        if (this.mobileTime > 0) {
          this.mobileVerifyText = this.mobileTime + 's';
          this.mobileVerifyDisabled = true;
        } else {
          this.mobileVerifyText = '验证';
          this.mobileVerifyDisabled = false;
        }
      },
      emailTime() {
        if (this.emailTime > 0) {
          this.emailVerifyText = this.emailTime + 's';
          this.emailVerifyDisabled = true;
        } else {
          this.emailVerifyText = '验证';
          this.emailVerifyDisabled = false;
        }
      }
    },
    methods: {
      hasMeRecord() {
        hasMeRecord().then(m => {
          if (m.errcode === 0) {
            var hasRecord = m.data;
            this.fullNameAllowEdit = hasRecord;
          }
        });
      },
      sexChange(value) {
        this.form.sex_id = value;
        if (value === 0) {
          this.form.sex = '';
        } else {
          let obj = this.$refs.sex.options.find((item) => {
            return item.PuBasicdataID === value;
          });
          this.form.sex = obj.DaName;
        }
      },
      getFullCityName(city_id) {
        fullCityName({
          city_id: city_id
        }).then(m => {
          if (m.errcode == 0) {
            if (this.form.live_city_id == city_id) {
              this.form.live_city = m.data;
            }
            if (this.form.native_city_id == city_id) {
              this.form.native_city = m.data;
            }
          }
        });
      },
      marriedStatusChange(value) {
        this.form.married_status_id = value;
        if (value === 0) {
          this.form.married_status = '';
        } else {
          let obj = this.$refs.marriedstatus.options.find((item) => {
            return item.PuBasicdataID === value;
          });
          this.form.married_status = obj.DaName;
        }
      },

      upload() {
        this.$refs['cropper'].upload();
      },
      // 上传头像成功回调  
      uploadHandle(data) {
        if (data.errcode == 0) {
          this.form.path = data.data.path;
          this.form.photo = data.data.img;
        }
      },
      cancel() {
        this.display = false;
      },
      confirm() {
        this.$refs['form'].validate((valid) => {
          if (!valid) return false;
          this.display = false;
          this.$emit('change', this.form);
        });
      },
      closeDialog() {
        this.$emit('visibleChange', false);
      },
      showShadow() {
        this.isShowShadow = true;
      },
      hideShadow() {
        this.isShowShadow = false;
      },
      onNativeCityChange(val) {
        var cityId = 0;
        if (val && Array.isArray(val)) {
          cityId = val[val.length - 1];
        }

        let number = Number(cityId);
        this.form.native_city_id = number > 0 ? cityId : '';
        if (number > 0) {
          this.getFullCityName(cityId);
        } else {
          this.form.native_city = '';
        }
      },
      onLiveCityChange(val) {
        var cityId = 0;
        if (val && Array.isArray(val)) {
          cityId = val[val.length - 1];
        }
        let number = Number(cityId);
        this.form.live_city_id = number > 0 ? cityId : '';
        if (number > 0) {
          this.getFullCityName(val);
        } else {
          this.form.live_city = '';
        }
      },
      getMobileVerifyCode() {
        if (!this.$Shared.isMobile(this.form.mobile)) {
          this.$message.error('请输入正确的手机号码');
          return false;
        }
        var params = {
          mobile: this.form.mobile
        };
        getMobileVerifyCode(params).then(m => {
          if (m.errcode === 0) {
            this.mobileVerifyVisible = true;
            this.mobileVerifyCode = '';
            this.mobileTime = 60;
            this.mobileTimer();
          } else {
            this.$message.error('获取验证码失败，失败原因：' + m.errmsg);
          }
        });
      },
      mobileTimer() {
        if (this.mobileTime > 0) {
          this.mobileTime--;
          setTimeout(this.mobileTimer, 1000);
        } else {
          this.mobileTime = 0;
        }
      },
      onChangeMobile() {
        if (!this.$Shared.isMobile(this.form.mobile)) {
          this.$message.error('请输入正确的手机号码');
          return false;
        }
        if (!this.mobileVerifyCode) {
          this.$message.error('请输入验证码');
          return false;
        }
        var params = {
          mobile: this.form.mobile,
          captcha: this.mobileVerifyCode
        };
        changeMobile(params).then(m => {
          if (m.errcode === 0) {
            this.$message.success('手机修改成功');
            this.mobileVerifyVisible = false;
          } else {
            this.$message.error('手机修改失败，失败原因：' + m.errmsg);
          }
        });
      },

      getEmailVerifyCode() {
        if (!this.$Shared.isEmail(this.form.email)) {
          this.$message.error('请输入正确的电子邮箱');
          return false;
        }
        var params = {
          email: this.form.email
        };
        getEmailVerifyCode(params).then(m => {
          if (m.errcode === 0) {
            this.emailVerifyVisible = true;
            this.emailVerifyCode = '';
            this.emailTime = 60;
            this.emailTimer();
          } else {
            this.$message.error('获取验证码失败，失败原因：' + m.errmsg);
          }
        });
      },
      onChangeEmail() {
        if (!this.$Shared.isEmail(this.form.email)) {
          this.$message.error('请输入正确的电子邮箱');
          return false;
        }
        if (!this.emailVerifyCode) {
          this.$message.error('请输入验证码');
          return false;
        }
        var params = {
          email: this.form.email,
          captcha: this.emailVerifyCode
        };
        changeEmail(params).then(m => {
          if (m.errcode === 0) {
            this.$message.success('邮箱修改成功');
            this.emailVerifyVisible = false;
          } else {
            this.$message.error('邮箱修改失败，失败原因：' + m.errmsg);
          }
        });
      },
      emailTimer() {
        if (this.emailTime > 0) {
          this.emailTime--;
          setTimeout(this.emailTimer, 1000);
        } else {
          this.emailTime = 0;
        }
      },
    }
  };
</script>

<style>
</style>